<template>
  <div>
    <Filtro @projetoAstecFiltrados="atualizarFiltro"/>
    <div>
      <div class="text-center" v-if="loadingGridProjetos === true">
        <b-spinner class="ms-2" variant="primary"></b-spinner>
      </div>

      <Grid
        v-else
        :items="projetosListados"
        :filtro="filtroProjetoAstec"
        @projetoAstecFiltrados="atualizarFiltro"
      />
    </div>
  </div>
</template>

<script>
import Grid              from "@/components/astec/projetos/gridProjetos";
import Filtro            from "@/components/astec/projetos/filtro";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins: [clienteRuralMixin],
  components: {
    Grid,
    Filtro
  },
  data() {
    return {
      filtro: {},
      filtroProjetoAstec: {},
      projetosListados: {
        data: [],
        total: 0,
        current_page: 1
      },
      loadingGridProjetos: true,
      limparFiltro: false,
    };
  },

  created() {
    this.$store.commit("PARAMETROS_PROJETO_ASTEC", null);
  },

  methods: {
    async atualizarFiltro(filtro, callback) {
      this.filtroProjetoAstec = filtro;

      const page = filtro.page || 1;
      const perPage = filtro.per_page || 10;

      let objFiltrado = await this.buscarItensProjetos(filtro, page, perPage);
      this.projetosListados = objFiltrado;

      if (typeof callback === 'function') {
        callback();
      }
    }
  }
};
</script>
